__turbopack_context__.v({
  "blockWrapper": "IFrameForm-module__NTwZAq__blockWrapper",
  "continueContainer": "IFrameForm-module__NTwZAq__continueContainer",
  "donationAmountInput": "IFrameForm-module__NTwZAq__donationAmountInput",
  "headingMargin": "IFrameForm-module__NTwZAq__headingMargin",
  "iFrameInnerContainer": "IFrameForm-module__NTwZAq__iFrameInnerContainer",
  "paymentMethodSelection": "IFrameForm-module__NTwZAq__paymentMethodSelection",
  "sslLogo": "IFrameForm-module__NTwZAq__sslLogo",
});
